// extracted by mini-css-extract-plugin
export default {"addNoteModal":"AddNotes_addNoteModal__lb-CJ"};